<h2 mat-dialog-title>{{tituloTxt}}</h2>
<mat-dialog-content style="min-width: 400px; min-height: 100px;">
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Nombre</mat-label>
      <input
        formControlName="nombre"
        matInput
        placeholder="Nombre de la disciplina"
        value=""
      />
      <mat-error>El nombre es requerido</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Minutos ingreso previo</mat-label>
      <input
        formControlName="minutosIngresosPrevioEntreno"
        matInput
        placeholder="Minutos máximos para ingresar"
        value=""
      />
      <mat-error>El valor es requerido o no es válido</mat-error>
    </mat-form-field>
    <input type="hidden" formControlName="id" value="" />

    <div class="example-full-width">
      <mat-slide-toggle class="example-margin" formControlName="estado">
        Estado
      </mat-slide-toggle>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
  >
    Guardar
  </button>
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
